"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowActionTypeLabel = exports.WorkflowActionType = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var WorkflowActionType;
(function (WorkflowActionType) {
    WorkflowActionType["SEND_EMAIL"] = "send-email";
    WorkflowActionType["ASSIGN_ISSUE"] = "assign-issue";
    WorkflowActionType["SET_ISSUE_DEADLINE"] = "set-issue-deadline";
    WorkflowActionType["NOTIFY_OP"] = "notify-op";
    WorkflowActionType["NOTIFY_ISSUE"] = "notify-issue";
    WorkflowActionType["NOTIFY_ASSET"] = "notify-asset";
    WorkflowActionType["RAISE_ISSUE"] = "raise-issue";
    WorkflowActionType["ASSIGN_OP"] = "assign-op";
    WorkflowActionType["ASSIGN_OP_ISSUE_CLOSED"] = "assign-op-issue-closed";
    WorkflowActionType["SEND_SMS"] = "send-sms";
    WorkflowActionType["IQM_CREATE_WORKFLOW"] = "iqm-create-workflow";
})(WorkflowActionType = exports.WorkflowActionType || (exports.WorkflowActionType = {}));
exports.default = WorkflowActionType;
function workflowActionTypeLabel(a) {
    switch (a) {
        case WorkflowActionType.SEND_EMAIL:
            return lib_i18n_1.default.t('send-email');
        case WorkflowActionType.ASSIGN_ISSUE:
            return lib_i18n_1.default.t('assign-issue');
        case WorkflowActionType.SET_ISSUE_DEADLINE:
            return lib_i18n_1.default.t('set-issue-deadline');
        case WorkflowActionType.NOTIFY_OP:
            return lib_i18n_1.default.t('notify-op');
        case WorkflowActionType.NOTIFY_ISSUE:
            return lib_i18n_1.default.t('notify-issue');
        case WorkflowActionType.NOTIFY_ASSET:
            return lib_i18n_1.default.t('notify-asset');
        case WorkflowActionType.RAISE_ISSUE:
            return lib_i18n_1.default.t('raise-issue');
        case WorkflowActionType.ASSIGN_OP:
            return lib_i18n_1.default.t('assign-op');
        case WorkflowActionType.ASSIGN_OP_ISSUE_CLOSED:
            return lib_i18n_1.default.t('assign-op-issue-closed');
        case WorkflowActionType.SEND_SMS:
            return lib_i18n_1.default.t('send-sms');
        case WorkflowActionType.IQM_CREATE_WORKFLOW:
            return lib_i18n_1.default.t('iqm-create-workflow');
    }
}
exports.workflowActionTypeLabel = workflowActionTypeLabel;
